<template>
  <v-container class="grey lighten-5">
      <v-row >
        <v-col cols="12" sm="6" xs="6">
          <h5>Buscar Producto:</h5>
          <v-text-field
                      v-model="sword"
                      hide-details
                      prepend-icon="mdi-magnify"
                      single-line        
                      placeholder="Escribe un sku, producto..."
                      v-on:keyup.13="getDataProduct(sword)"
                      autofocus
          ></v-text-field>
        </v-col>       
        <v-col cols="12" sm="6" xs="6">
          <!-- filter -->
            <template>
                    <v-card
                      class="mx-auto"
                      max-width="400"
                    >
                      <v-toolbar color="purple">
                        <v-toolbar-title>Filtros de Busqueda</v-toolbar-title>
                        <v-spacer></v-spacer>
                      </v-toolbar>


                      <v-divider></v-divider>

                      <v-list lines="three" select-strategy="classic">
                        <v-list-subheader>Almacen</v-list-subheader>
                        <v-list-item value="notifications">
                          <v-radio-group
                            v-model="warehouseid"
                            column
                            >
                            <v-radio
                              label="Todos"
                              value=""
                              @click="getDataProductW(warehouseid)"
                            ></v-radio>

                            <!-- label="El Pilar Cloudbits" -->
                            <!-- value="3" -->
                             <div
                                v-for="warehouse in warehouses" :key="warehouse.id"
                             >
                                <v-radio
                                :label="`${warehouse.name}`"
                                :value="`${warehouse.id}`"
                                @click="getDataProductW(warehouseid)"
                                ></v-radio>                            
                              </div>
                          </v-radio-group>
                          <!-- <v-checkbox  class="my-0 py-0" v-model="stock" :value="`${pstock.value}`" :label="`${pstock.description}`"> </v-checkbox> -->
                        </v-list-item>
                      </v-list>
                    </v-card>
            </template>
          <!-- FIN filter -->
        </v-col>       
      </v-row>                                                                         
  </v-container>

</template>


<script>
import{ mapMutations,mapState } from "vuex";
// import validations from '@/utils/validation';
// import{ DataManager,Query, WebApiAdaptor } from "@syncfusion/ej2-data";
// import baseApi from '@/services/baseApi';
// import router from '@/router';


export default {
  name: 'FieldSearch',  
  components: {
  },  
  computed:{
    // 'products',
    ...mapState(['priceslist','warehouses']),
    // priceslist:{
    //   get(){
    //     //.toLowerCase() Para no aceptar Mayusculas
    //     return this.$store.state.filter.query;
    //   },
    //   set(val){
    //     this.$store.commit('SET_QUERY',val);
    //   }
    // },

  },
  props: {
    // product: Object,
    refresh: Boolean,
  },
  watch: { 
    // priceid: function(newVal, oldVal) { // watch it
    refresh: function() { // watch it
          // let products=JSON.stringify(this.car_products);
          // this.$store.dispatch('loadResetPricelist',products); 
          let products=[]
          this.$store.commit('SET_PRICESLIST',products);   
          this.sword=''
          // this.getDataProduct('')  
          // refresh.resetEmitted();
    }
  },
  methods:{
    ...mapMutations(["showLoading","hiddenLoading"]),   
    getTextShort(text){
      if (text.length > 35) {
       return text.slice(0, 35)+'...'
      }else return text
    },
    async getWarehouses(){
        // alert('alamcen');
        await this.$store.dispatch('loadWarehouses',this.attribute);
        // this.showLoading({titulo:"Accediendo información",color:"primary"})

    },
    async getDataProductW(warehouseid) {
      // alert(sword);
      this.attribute.warehouseid=warehouseid;
          try{        
            this.showLoading({titulo:"Accediendo información del Cliente",color:"warning"})
            await this.$store.dispatch('loadPricelists2',this.attribute);  
          }catch(error){
            console.log(error);
          }finally{
            this.hiddenLoading()
          } 
          // console.log(this.priceslist)
          this.$emit('priceslist-id', this.priceslist);          
    },
    async getDataProduct(sword) {
          // alert(this.attribute.warehouseid  );
          this.attribute.sword=sword
          try{        
            this.showLoading({titulo:"Accediendo información del Cliente",color:"warning"})
            await this.$store.dispatch('loadPricelists2',this.attribute);  
          }catch(error){
            console.log(error);
          }finally{
            this.hiddenLoading()
          } 
          // console.log(this.priceslist)
          this.$emit('priceslist-id', this.priceslist);          
    },
    getPriceID(valor){
      this.$emit('price-id', valor);
      // alert(valor)
    }
  },
  data(){
     return{
      sword:'',
      warehouseid:'',
      attribute: {
        sword: 'All',
        status:'',
        warehouseid:'',
        // date_start:'2019-01-01',
        // date_end:new Date().toISOString().substr(0,10),
        // pricelistid:'',
        limit: 35
      },
     }
  },
  destroyed() {
    console.log("Componente eliminado");
  },
  mounted(){
    console.log("Montado Product Form");
    // if (this.hasValorID>0) {
    //   this.getDataProduct(this.hasValorID)
    // }
  },
  created(){
    // this.getDataProduct('')  
    this.getWarehouses();
  }  
}
</script>

